import { Component } from '@angular/core';
import { ZoomOnScrollDirective } from '../../../../shared/directives/zoom-on-scroll.directive';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'landing-start-booking',
    imports: [ZoomOnScrollDirective],
    templateUrl: './start-booking.component.html',
    styleUrl: './start-booking.component.scss'
})
export class LandingStartBookingComponent {
    assetUrl = environment.assetBaseUrl
}
